export const CUISINES = [
  "Afghan", "Argentinian", "American", "Brazilian", "Cajun", "Caribbean",
  "Chilean", "Chinese", "Colombian", "Cuban", "Dominican", "Ecuadorian",
  "Egyptian", "English", "Ethiopian", "Filipino", "French", "German", "Greek",
  "Guatemalan", "Haitian", "Hawaiian", "Honduran", "Indian", "Indonesian",
  "Irish", "Israeli", "Italian", "Jamaican", "Japanese", "Korean",
  "Lebanese", "Malaysian", "Mediterranean", "Mexican", "Middle Eastern",
  "Moroccan", "Nepalese", "Nigerian", "Pakistani", "Peruvian", "Polish",
  "Portuguese", "Puerto Rican", "Romanian", "Russian", "Salvadoran", "Scottish", "Singaporean",
  "Soul Food", "Southern", "Spanish", "Sri Lankan", "Taiwanese", "Thai",
  "Trinidadian", "Turkish", "Venezuelan", "Vietnamese", "Other",
];

// Returns a translation key-friendly object
export function getCredibilityLabel(count) {
  if (count >= 16) return { label: "expert", labelKey: "credibility.expert", tier: 3 };
  if (count >= 6) return { label: "regular", labelKey: "credibility.regular", tier: 2 };
  return { label: "triedIt", labelKey: "credibility.triedIt", tier: 1 };
}

export function getCredibilityStyle(tier) {
  if (tier === 3) return { color: "text-amber-400", bg: "bg-amber-400/10", border: "border-amber-400/30" };
  if (tier === 2) return { color: "text-blue-400", bg: "bg-blue-400/10", border: "border-blue-400/30" };
  return { color: "text-th-muted", bg: "bg-th-surface", border: "border-th-border" };
}
